import { z } from 'zod'
import { format } from '@tabeo/sharpei/utils/currency'
import { emailPCA } from '@tabeo/sharpei/utils/validations'

export function zodValidator<T>(schema: z.ZodType<T>) {
  return async (values: any) => {
    try {
      await schema.parseAsync(values)
      return {}
    } catch (error) {
      const fieldErrors: any = {}
      const { errors } = error as z.ZodError

      errors.forEach(error => {
        let current = fieldErrors

        error.path.forEach((path, index) => {
          const nextPath = error.path[index + 1]

          if (nextPath === undefined) {
            current[path] = error.message
            return
          }

          if (Number.isInteger(nextPath)) {
            current[path] = current[path] || []
            current = current[path]
            return
          }

          current[path] = current[path] || {}
          current = current[path]
        })
      })

      return fieldErrors
    }
  }
}

export const tabeoErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === 'invalid_type') {
    if (['undefined', 'nan', 'null'].includes(issue.received)) {
      return { message: 'Field is required' }
    }
  }

  if (issue.code === 'too_small') {
    if (issue.type === 'number') {
      return {
        message: `Must be at least or equat to ${issue.minimum}`,
      }
    }

    if (issue.type === 'string') {
      // A min(1) string is the same "you must fill this in" as a missing one.
      if (issue.minimum === 1) {
        return { message: 'Field is required' }
      }

      return {
        message: `Must be ${issue.minimum} characters or more`,
      }
    }
  }

  if (issue.code === 'too_big') {
    if (issue.type === 'number') {
      return {
        message: `Must be less or equal to ${issue.maximum}`,
      }
    }

    if (issue.type === 'string') {
      return {
        message: `Must be ${issue.maximum} characters or less`,
      }
    }
  }

  if (issue.code === 'invalid_string') {
    if (issue.validation === 'email') {
      return {
        message: 'Invalid email address format',
      }
    }
  }

  return { message: issue.message || ctx.defaultError }
}

export const priceValidationMessage = (min: number, max: number) => {
  return {
    message: `Please specify an amount between ${format(min)} and ${format(
      max
    )}`,
  }
}

export const zodEmailPCA = z.string().refine(async value => {
  const error = await emailPCA(value)
  return !error
}, 'Email address is not valid')
